export const organizationsSearchTriggerDataId = 'organizations-search-trigger'
